module.exports = __webpack_public_path__ + "static/media/pin_large.9a029410.svg";